import React, { useEffect } from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import "./index.css";
import AOS from "aos";
import "aos/dist/aos.css";

const root = ReactDOM.createRoot(document.getElementById("root"));

const Main = () => {
  useEffect(() => {
    AOS.init({ duration: 1000 });
  }, []);

  return <App />;
};

root.render(
  <React.StrictMode>
    <Main />
  </React.StrictMode>
);
